// private config
const env = process.env.REACT_APP_CUSTOM_ENV.trim();
const custom_var = process.env.REACT_APP_SOLUTION.trim();
console.log(`Custom Var: ${custom_var}`);

let euRegion = new URLSearchParams(location.search).get("euregion");
let sydneyRegion = new URLSearchParams(location.search).get("sydneyregion");
// If EU Region not available, Make it false
euRegion = euRegion == 'true' ? euRegion : 'false'

// If Sydney Region not available, Make it false
sydneyRegion = sydneyRegion == 'true' ? sydneyRegion : 'false'

console.log(`The Sydney Region Settings: ${sydneyRegion}`)
console.log(`The EU Region Settings: ${euRegion}`)

if (euRegion == "true") {
  sessionStorage.setItem("euRegion", "true");
}

if (sydneyRegion == 'true') {
    sessionStorage.setItem('sydneyRegion', 'true')
}
const environment = env === "production" ? "" : env === 'test' ? " Test" : env === 'demo' ? ' Demo' : env === 'sandbox' ? " Sandbox" : " Dev"

const appName = "Outbound List Manager" + environment;
const provisioningInfo = {
  roles: [
    {
      name: appName,
      description:
        "Generated role that is used by the application backend for ",
      permissionPolicies: [
        {
          // permission to allow backend to retrieve all integration types in validate org
          domain: "integrations",
          entityName: "integration",
          actionSet: ["view"],
          allowConditions: false,
        },
        {
          domain: "authorization",
          entityName: "role",
          actionSet: ["*"],
          allowConditions: false,
        },
        {
          domain: "analytics",
          entityName: "userDetail",
          actionSet: ["view"],
          allowConditions: false,
        },
        {
          domain: "outbound",
          entityName: "contact",
          actionSet: ["*"],
          allowConditions: false,
        },
        {
          domain: "outbound",
          entityName: "contactList",
          actionSet: ["*"],
          allowConditions: false,
        },
        {
          domain: "outbound",
          entityName: "dncList",
          actionSet: ["*"],
          allowConditions: false,
        },
        {
          domain: "outbound",
          entityName: "dnc",
          actionSet: ["*"],
          allowConditions: false,
        },
      ],
      type: "oauth",
    },
  ],
  oauth: {
    name: appName + " OAuth",
    description: `Generated OAuth Client that is used by the application backend`,
    authorizedGrantType: "CLIENT_CREDENTIALS",
    id: "01840872-f099-4596-a276-5297cf596fe2",
  },
};

const development = {
    purecloud: {
        clientId: '8a4ef85f-cfb9-4001-820b-b4ed74a3637d',// psinnovations org
        applicationName: appName,
        baseUrl: 'http://localhost:3000/'
    },
    pureengage: {

    },
    integrationType: "premium-app-outbound-list-manager",
    permissionPolicyEntityName: "examplePremiumApp",
    defaultPcEnv: 'mypurecloud.com',
    defaultLangTag: "en-us",
    provisioningInfo: provisioningInfo,
    product: 'purecloud',
    endpoints: {
         apiEndpoint: 'https://zmua37hq8e.execute-api.us-east-1.amazonaws.com/dev',
    }
}

const test = {
    purecloud: {
        clientId: '8a4ef85f-cfb9-4001-820b-b4ed74a3637d', //pssinovations
        applicationName: appName,
        baseUrl: ''
    },
    integrationType: "embedded-client-app",
    permissionPolicyEntityName: "examplePremiumApp",
    defaultPcEnv: 'mypurecloud.com',
    defaultLangTag: "en-us",
    provisioningInfo: provisioningInfo,
    product: 'purecloud',
    endpoints: {
        apiEndpoint: '',
    }
}

const production = {
    purecloud: {
        clientId: '5e97589a-5e4e-4550-bba4-2c4fb8488cf2', //genesysprofessionalservicesexpertapps
        applicationName: appName
    },
    pureengage: {

    },
    integrationType: "premium-app-outbound-list-manager",
    permissionPolicyEntityName: "examplePremiumApp",
    defaultPcEnv: 'mypurecloud.com',
    defaultLangTag: "en-us",
    provisioningInfo: provisioningInfo,
    product: 'purecloud',
    endpoints: {
        apiEndpoint: 'https://5bkcq5s926.execute-api.us-east-1.amazonaws.com/prod',
    }
}

const sandbox = {
    purecloud: {
        clientId: '5e97589a-5e4e-4550-bba4-2c4fb8488cf2',//genesysprofessionalservicesexpertapps
        applicationName: appName,
        baseUrl: 'https://d2of5q2bdvks90.cloudfront.net'
    },
    pureengage: {

    },
    integrationType: "embedded-client-app",
    permissionPolicyEntityName: "examplePremiumApp",
    defaultPcEnv: 'mypurecloud.com',
    defaultLangTag: "en-us",
    provisioningInfo: provisioningInfo,
    product: 'purecloud',
    endpoints: {
        apiEndpoint: 'https://jrsmic161a.execute-api.us-east-1.amazonaws.com/sandbox',
    }
}


console.log('env:', env)
let config
switch (env) {
  case "production":
    config = production;
    break;
  case "development":
    config = development;
    break;
  case "test":
    config = test;
    break;
  case "sandbox":
    config = sandbox;
    break;
  default:
    break;
}

let sydneyRegionStatus = sessionStorage.getItem('sydneyRegion')

if (sydneyRegionStatus && sydneyRegionStatus == 'true')
    config.endpoints.apiEndpoint = config.endpoints.sydneyApiEndpoint;

config.sunCorpOrgIdPool = [
    // '43a8e287-d8ed-4a89-828e-244f1152f051', // PS Innovations
    'de14a2d7-7a48-426c-ba7d-2dee57a39ecb', // Sun Corp Dev
]

config.wmOrgIdPool = [
    'b01b0578-da8d-4ae0-bf6d-1dff8e14e9dc', // Waste Management
    // '43a8e287-d8ed-4a89-828e-244f1152f051',
]
let euRegionStatus = sessionStorage.getItem('euRegion')

if (euRegionStatus && euRegionStatus == "true")
  config.endpoints.apiEndpoint = config.endpoints.euApiEndpoint;

let sunCorpPoolFlag = sessionStorage.getItem('sunCorpPoolFlag');

if (sunCorpPoolFlag && sunCorpPoolFlag === 'true') {
    config.endpoints.apiEndpoint = config.endpoints.sunCorpEndpoint;
}

let wmPoolFlag = sessionStorage.getItem('wmPoolFlag');

if (wmPoolFlag && wmPoolFlag === 'true') {
    config.endpoints.apiEndpoint = config.endpoints.wmEndpoint;
}

export const accessToken = () => {
  return JSON.parse(
    sessionStorage.getItem("purecloud-csp-token") ||
      sessionStorage.getItem(
        `purecloud-csp-token-${sessionStorage.getItem("orgId")}`
      )
  );
};

export const getEnv = () => {
  return JSON.parse(
    sessionStorage.getItem("purecloud-csp-env") ||
      sessionStorage.getItem(
        `purecloud-csp-env-${sessionStorage.getItem("orgId")}`
      )
  );
};

export const getStoredTenant = () => {
  return JSON.parse(sessionStorage.getItem("purecloud-csp-tenant"));
};

export default config;
export const headerTitle = "Genesys Template";
